module.exports = __webpack_public_path__ + "static/media/noun_add_2768148.64ac5045.svg";